import { ResponseStatus } from "../agenda/AgendaItemResponseStatus";
import EventLocation from "./EventLocation";

export enum MeetingMessageType {
    MEETING_REQUEST = "meetingRequest",
    MEETING_ACCEPTED = "meetingAccepted",
    MEETING_DECLINED = "meetingDeclined",
    MEETING_TENTATIVE = "meetingTentative",
    MEETING_CANCELLED = "meetingCancelled",
    MEETING_UPDATED = "meetingUpdated",
}

export enum MeetingRequestType {
    MEETING_REQUEST = "meetingRequest",
    MEETING_RESPONSE = "meetingResponse",
    MEETING_CANCELLATION = "meetingCancellation",
    MEETING_UPDATE = "meetingUpdate",
}

type EventDetailProps = {
    eventSentDateTime: Date;
    meetingMessageType: MeetingMessageType;
    meetingRequestType: MeetingRequestType;
    subject: string;
    startDateTime?: Date;
    endDateTime?: Date;
    isAllDay: boolean;
    responseRequested: boolean;
    isDelegated: boolean;
    location?: EventLocation;
    id?: string;
    userResponseStatus?: ResponseStatus;
};

export default class EventDetail {
    eventSentDateTime: Date;

    meetingMessageType: MeetingMessageType;

    meetingRequestType: MeetingRequestType;

    subject: string;

    startDateTime?: Date;

    endDateTime?: Date;

    isAllDay: boolean;

    responseRequested: boolean;

    isDelegated: boolean;

    location?: EventLocation;

    id?: string;

    userResponseStatus?: ResponseStatus;

    constructor({
        eventSentDateTime,
        meetingMessageType,
        meetingRequestType,
        subject,
        startDateTime,
        endDateTime,
        isAllDay,
        responseRequested,
        isDelegated,
        location,
        id,
        userResponseStatus,
    }: EventDetailProps) {
        this.eventSentDateTime = eventSentDateTime;
        this.meetingMessageType = meetingMessageType;
        this.meetingRequestType = meetingRequestType;
        this.subject = subject;
        this.startDateTime = startDateTime;
        this.endDateTime = endDateTime;
        this.isAllDay = isAllDay;
        this.responseRequested = responseRequested;
        this.isDelegated = isDelegated;
        this.location = location;
        this.id = id;
        this.userResponseStatus = userResponseStatus;
    }

    getUserAcceptedStatus(): ResponseStatus {
        return this.userResponseStatus ?? ResponseStatus.None;
    }
}
